<app-signing-order-editor
  #signingOrder
  [itemsFormArray]="form"
  labelKey="role"
  [sortable]="templateType !== templateTypes.Document"
>
  <ng-template signerForm let-roleForm="form" let-index="index">
    <app-role-item-form
      [form]="roleForm"
      [isRoleEditable]="isRolesEditable"
      [removable]="form.length >= 2"
      (roleSelect)="onRoleSelect($event, roleForm)"
      (remove)="onRemoveRole(index)"
    ></app-role-item-form>
  </ng-template>
</app-signing-order-editor>

<div class="mt-3" *ngIf="isRolesEditable">
  <a
    i18n-matTooltip
    matTooltip="Add a new signer to this template."
    class="btn btn-secondary-info"
    (click)="onAddRole()"
    *ngIf="form.length < rolesLimit"
  >
    <i class="far fa-plus"></i> <ng-container i18n>Add Signer</ng-container>
  </a>
</div>
